import { ApolloClient, InMemoryCache, HttpLink, from, ApolloLink, gql } from "@apollo/client/core"
import { Observable } from "@apollo/client/utilities"
import { onError } from "@apollo/client/link/error"

export { gql } from "@apollo/client/core"

export function finalApolloClient(options: CMSApolloOptions): ApolloClient<any> {
  const cache = new InMemoryCache()

  const request = operation => {
    operation.setContext({
      headers: options.headers || {}
    })
  }

  const requestLink = new ApolloLink((operation, forward) => {
    return new Observable(observer => {
      let handle
      Promise.resolve(operation)
        .then(oper => request(oper))
        .then(() => {
          handle = forward(operation).subscribe({
            next: observer.next.bind(observer),
            error: observer.error.bind(observer),
            complete: observer.complete.bind(observer)
          })
        })
        .catch(observer.error.bind(observer))

      return () => {
        if (handle) {
          handle.unsubscribe()
        }
      }
    })
  })

  const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      graphQLErrors.forEach(({ message, locations, path }) =>
        console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
      )
    }
    if (networkError) {
      if (["ServerParseError", "ServerError"].includes(networkError.name)) {
        const serverError = networkError as any
        if (serverError.statusCode === 502) {
          console.log("[Server error]: 502 Bad Gateway")
        } else {
          console.log(`[Server error]: ${serverError.statusCode}`)
        }
      } else {
        console.log(`[Network error]: ${networkError}`)
      }
    }
  })

  const client = new ApolloClient({
    ssrMode: true,
    link: from([
      errorLink,
      requestLink,
      new HttpLink({
        uri: options.uri,
        credentials: "same-origin"
      })
    ]),
    cache
  })

  cache.writeQuery({
    query: gql`
      query GetNetworkStatus {
        isConnected
      }
    `,
    data: {
      isConnected: true
    }
  })

  return client
}
